package eu.codlab.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import androidx.navigation.compose.rememberNavController
import eu.codlab.viewmodel.rememberViewModel

val LocalNavigator: ProvidableCompositionLocal<NavigatorModel> =
    compositionLocalOf { error("No LocalNavigator defined") }

@Composable
fun NavigatorLocalProvider(
    model: NavigationListener,
    content: @Composable () -> Unit
) {
    val navigator = rememberNavController()
    val navigatorModel = rememberViewModel { NavigatorModel() }

    DisposableEffect(navigator, navigatorModel) {
        println("navigatorModel.setNavigator($$navigator)")
        navigatorModel.setNavigator(navigator)
        navigatorModel.navigationListener = model

        onDispose { navigatorModel.setNavigator(null) }
    }

    CompositionLocalProvider(
        LocalNavigator provides navigatorModel,
        content = content
    )
}
